import React from 'react';
import { CheckCircle, Target, Award, Zap } from 'lucide-react';

const AboutPage = () => {
  const features = [
    {
      icon: CheckCircle,
      title: 'Confiança Absoluta',
      description: 'Parceria transparente e resultados comprováveis'
    },
    {
      icon: Target,
      title: 'Inovação Contínua',
      description: 'Tecnologias de ponta e atualização constante'
    },
    {
      icon: Award,
      title: 'Atendimento Premium',
      description: 'Suporte personalizado e dedicado ao seu sucesso'
    },
    {
      icon: Zap,
      title: 'Agilidade Local',
      description: 'Base em Cariacica-ES, atendimento em todo Brasil'
    }
  ];

  return (
    <div className="page-container">
      <section className="about-hero">
        <h1 className="page-title">Sobre a WEGTECH</h1>
        <p className="page-subtitle">
          Parceiro estratégico em tecnologia segura para empresas
        </p>
      </section>

      <section className="about-content">
        <div className="content-block">
          <h2 className="content-title">Quem Somos</h2>
          <p className="content-text">
            A WEGTECH é o parceiro estratégico em tecnologia segura para empresas que 
            precisam de soluções confiáveis sem complicações internas. Especializados 
            em cibersegurança, networking, pentest, infraestrutura e revenda enterprise, 
            cuidamos da sua TI para você focar no crescimento do negócio.
          </p>
        </div>

        <div className="content-block">
          <h2 className="content-title">Nossa Missão</h2>
          <p className="content-text">
            Entregar proteção e performance tecnológica com excelência e suporte 
            personalizado.
          </p>
        </div>

        <div className="values-section">
          <h2 className="content-title">Nossos Valores</h2>
          <div className="values-grid">
            {features.map((feature, index) => {
              const IconComponent = feature.icon;
              return (
                <div key={index} className="value-card">
                  <div className="value-icon">
                    <IconComponent size={32} />
                  </div>
                  <h3 className="value-title">{feature.title}</h3>
                  <p className="value-description">{feature.description}</p>
                </div>
              );
            })}
          </div>
        </div>

        <div className="differentials-section">
          <h2 className="content-title">Nossos Diferenciais</h2>
          <div className="differentials-list">
            <div className="differential-item">
              <div className="differential-marker"></div>
              <span>Soluções personalizadas para cada negócio</span>
            </div>
            <div className="differential-item">
              <div className="differential-marker"></div>
              <span>SLA garantido com suporte prioritário</span>
            </div>
            <div className="differential-item">
              <div className="differential-marker"></div>
              <span>Equipe certificada e especializada</span>
            </div>
            <div className="differential-item">
              <div className="differential-marker"></div>
              <span>Agilidade local em Cariacica-ES, atendimento em todo Brasil</span>
            </div>
          </div>
        </div>

        <div className="cta-block">
          <h2 className="cta-title">Proteja seu futuro tech com quem entende do assunto</h2>
          <p className="cta-text">
            Entre em contato e descubra como podemos transformar a segurança e 
            performance da sua infraestrutura tecnológica.
          </p>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;